/* src/app/shared/styles/crm-billing.css */
.v2-page,
.go-embed {
  --v2-bg: #ffffff;
  --v2-bg-subtle: #f7f8fa;
  --v2-border: #e4e7ec;
  --v2-border-strong: #d0d5dd;
  --v2-text: #1d2433;
  --v2-text-muted: #64748b;
  --v2-text-faint: #94a3b8;
  --v2-primary: #5d87ff;
  --v2-primary-fg: #ffffff;
  --v2-primary-tint-bg: #eef2ff;
  --v2-primary-tint-fg: #3651c9;
  --v2-ok-bg: #e7f6ed;
  --v2-ok-fg: #1a7f45;
  --v2-warn-bg: #fdeceb;
  --v2-warn-fg: #b3261e;
  --v2-caution-bg: #fff4e5;
  --v2-caution-fg: #8a5600;
  --v2-neutral-bg: #eef1f5;
  --v2-neutral-fg: #475569;
  --v2-radius: 10px;
  --v2-radius-sm: 6px;
  --v2-shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.06);
  color: var(--v2-text);
}
.v2-page {
  padding: 16px 20px 32px;
}
.v2-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 14px;
}
.v2-head h2 {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.v2-sub {
  color: var(--v2-text-muted);
  font-size: 13px;
}
.v2-tab-body {
  padding: 18px 20px 20px;
  background: var(--v2-bg);
  border: 1px solid var(--v2-border);
  border-radius: var(--v2-radius);
  box-shadow: var(--v2-shadow-sm);
}
.v2-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.v2-toolbar.v2-toolbar-main {
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--v2-border);
}
.v2-spacer {
  flex: 1 1 auto;
}
.v2-toolbar button mat-icon {
  margin-right: 4px;
  vertical-align: middle;
}
.v2-inline-spin {
  margin-left: 4px;
}
.v2-inline-spin ::ng-deep circle {
  stroke: var(--v2-primary);
}
.v2-note {
  font-size: 13px;
  line-height: 1.55;
  color: var(--v2-text-muted);
  margin: 0 0 12px;
  max-width: 78ch;
}
.v2-note strong {
  color: var(--v2-text);
  font-weight: 600;
}
.v2-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  color: var(--v2-text-muted);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.v2-toggle input {
  accent-color: var(--v2-primary);
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.v2-toggle:focus-within {
  outline: 2px solid var(--v2-primary);
  outline-offset: 3px;
  border-radius: 3px;
}
.v2-tabs {
  margin-bottom: 0;
}
.v2-tabs ::ng-deep .mat-mdc-tab-header {
  border-bottom: 1px solid var(--v2-border);
}
.v2-tabs ::ng-deep .mdc-tab {
  min-width: 0;
}
.v2-tabs ::ng-deep .mdc-tab-indicator__content--underline {
  border-color: var(--v2-primary);
}
.v2-tabs ::ng-deep .mdc-tab .mdc-tab__text-label {
  color: var(--v2-text-muted);
  font-weight: 500;
}
.v2-tabs ::ng-deep .mdc-tab--active .mdc-tab__text-label {
  color: var(--v2-primary);
  font-weight: 600;
}
.v2-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.v2-tab-label mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: currentColor;
  opacity: 0.85;
}
.v2-tab-panel {
  padding-top: 18px;
}
.v2-tab-lead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}
.v2-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--v2-border);
  border-radius: var(--v2-radius-sm);
}
.v2-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: var(--v2-text-faint);
  text-align: center;
  font-style: normal;
  font-size: 13px;
  padding: 32px 16px;
}
.v2-empty mat-icon {
  font-size: 26px;
  height: 26px;
  width: 26px;
  color: var(--v2-border-strong);
}
.v2-plain-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.v2-plain-table th,
.v2-plain-table td {
  text-align: left;
  padding: 9px 12px;
  border-bottom: 1px solid var(--v2-border);
}
.v2-plain-table thead th {
  color: var(--v2-text-muted);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  background: var(--v2-bg-subtle);
  position: sticky;
  top: 0;
  z-index: 1;
}
.v2-plain-table tbody tr:hover {
  background: var(--v2-bg-subtle);
}
.v2-plain-table tbody tr:last-child td {
  border-bottom: none;
}
.v2-plain-table .num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.v2-invoice-total td {
  font-weight: 700;
  border-top: 2px solid var(--v2-border-strong);
  background: var(--v2-bg-subtle);
}
.v2-divider {
  border: none;
  border-top: 1px solid var(--v2-border);
  margin: 24px 0 16px;
}
.v2-subhead {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px;
  color: var(--v2-text);
}
.v2-error {
  color: var(--v2-warn-fg);
  font-style: normal;
}
.v2-empty.v2-error {
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
  color: var(--v2-warn-fg);
  background: var(--v2-warn-bg);
  border-radius: var(--v2-radius-sm);
  padding: 10px 14px;
  font-size: 13px;
}
.v2-empty.v2-error mat-icon {
  color: var(--v2-warn-fg);
  font-size: 20px;
  height: 20px;
  width: 20px;
}
.v2-file-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  border: 1px dashed var(--v2-border-strong);
  border-radius: var(--v2-radius-sm);
  padding: 7px 14px;
  font-size: 13px;
  color: var(--v2-text-muted);
  background: var(--v2-bg-subtle);
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition:
    border-color 120ms,
    color 120ms,
    background 120ms;
}
.v2-file-btn:hover {
  border-color: var(--v2-primary);
  color: var(--v2-primary);
  background: var(--v2-primary-tint-bg);
}
.v2-file-btn:has(input:focus-visible) {
  outline: 2px solid var(--v2-primary);
  outline-offset: 2px;
}
.v2-file-btn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.v2-file-btn.v2-file-set {
  border-style: solid;
  border-color: var(--v2-ok-fg);
  color: var(--v2-ok-fg);
  background: var(--v2-ok-bg);
}
.v2-recon-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 2px 0 12px;
}
.v2-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  background: var(--v2-neutral-bg);
  color: var(--v2-neutral-fg);
  line-height: 1.4;
}
.v2-chip-ok {
  background: var(--v2-ok-bg);
  color: var(--v2-ok-fg);
}
.v2-chip-warn {
  background: var(--v2-warn-bg);
  color: var(--v2-warn-fg);
}
.v2-flag-cell {
  color: var(--v2-warn-fg);
  font-weight: 600;
}
.v2-ref-cell {
  color: var(--v2-text-faint);
  font-style: italic;
}
.v2-reason {
  display: inline-block;
  border-radius: 999px;
  padding: 2px 9px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  background: var(--v2-warn-bg);
  color: var(--v2-warn-fg);
}
.v2-reason-partial-refund {
  background: var(--v2-caution-bg);
  color: var(--v2-caution-fg);
}
.v2-recon-diag {
  padding-top: 0;
}
.v2-recon-diag .v2-chip {
  background: var(--v2-bg-subtle);
  color: var(--v2-text-muted);
  border: 1px solid var(--v2-border);
}
.v2-group-breakdown td {
  background: var(--v2-bg-subtle);
  padding: 4px 12px 14px;
}
.v2-nested-table {
  font-size: 12px;
  margin: 0;
}
.v2-nested-table th,
.v2-nested-table td {
  padding: 5px 10px;
  border-bottom: 1px solid var(--v2-border);
}
.v2-av-files a {
  margin-right: 10px;
  color: var(--v2-primary);
  text-decoration: none;
  font-weight: 500;
}
.v2-av-files a:hover {
  text-decoration: underline;
}
.v2-av-by {
  color: var(--v2-text-faint);
  font-size: 12px;
}
.v2-saved-ok {
  color: var(--v2-ok-fg);
  font-weight: 600;
}
.v2-tab-label ::ng-deep .mat-badge-content {
  background: var(--v2-warn-fg);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}
/*# sourceMappingURL=crm-billing.css.map */
